<template>
    <div class="ah-page accounting-balance-sheet">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>會計資產負債表</h1>
                    </div>
                    <div class="actions">
                        <el-button @click="onPrintClick" icon="el-icon-printer">列印</el-button>
                        <el-button @click="onExport" icon="el-icon-download">匯出 Excel</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel no-print">
                <div class="panel-body">
                    <search-form>
                        <search-form-item label="查詢日期">
                            <div class="horizontal-inputs">
                                <ahDropdownDatePicker v-model="dateRange" :showEndPicker="false" :quickButton="false" @change="updateData" />
                            </div>
                        </search-form-item>
                        <search-form-item label="金額為 0 的科目">
                            <el-radio v-model="isShowZeroItems" :label="true" @change="updateData">顯示</el-radio>
                            <el-radio v-model="isShowZeroItems" :label="false" @change="updateData">隱藏</el-radio>
                        </search-form-item>
                    </search-form>
                </div>
            </div>
            <div class="ah-panel" style="margin-top: -20px">
                <div class="panel-body" :class="{ loading: isLoading }">
                    <TableView
                        :datas="datas"
                        :totals="totals"
                        :queryParams="queryParams"
                        :isLoading="isLoading"
                        :settlementDateTxt="settlementDateTxt"
                        :closedDateTxt="closedDateTxt"
                        @click="onClickItem"
                    />
                </div>
            </div>
        </div>
        <DetailDialog
            :visible="detailDialog.visible"
            :StartDate="queryParams.startDate"
            :EndDate="queryParams.queryDate"
            :accno="detailDialog.accno"
            :accnam="detailDialog.accnam"
            @close="onDetailDialogClose"
        />
    </div>
</template>

<script>
import moment from 'moment';
import ahDropdownDatePicker from '@/components/ui/ahDropdownDatePicker.vue';
import SearchForm from '@/components/ui/SearchForm/SearchForm.vue';
import SearchFormItem from '@/components/ui/SearchForm/SearchFormItem.vue';
import mixins from './mixins';
import { downloadExcel } from './exportExcelUtils';

export default {
    name: 'AccountingBalanceSheet',
    mixins: [mixins],
    components: {
        ahDropdownDatePicker,
        SearchForm,
        SearchFormItem,
    },
    async mounted() {
        this.dateRange = [parseInt(moment().format('x'), 10), null];
        this.updateData();
    },
    methods: {
        onPrintClick() {
            window.print();
        },
        onDetailDialogClose(refresh) {
            this.detailDialog.visible = false;
            if (refresh) this.updateData();
        },
        onExport() {
            downloadExcel(this.queryParams.queryDate, this.companyName);
        },
    },
};
</script>

<style lang="scss">
.accounting-balance-sheet {
    .action-bar {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    @media print {
        .ah-panel.actions {
            display: none;
        }
        .doc-action {
            display: none;
        }
        .no-print {
            display: none;
        }
    }
    .doc-action {
        text-align: right;
    }
    .datepicker-label {
        display: inline-block;
        margin-right: 24px;
        font-size: 10pt;
        color: #888;
    }

    .panel-body.loading {
        opacity: 0.5;
        transition: 0.2s;
    }
}
</style>
